import { Button, Tile } from "@2u-landing-pages/components";
import {
  TypeButtonWithoutUnresolvableLinksResponse,
  TypeTileWithoutUnresolvableLinksResponse,
} from "@2u-landing-pages/types";
// import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import cn from "classnames";
import React, { FC, useEffect, useRef, useState } from "react";
import { StickyElementProps } from "./StickyElement.types";
// @ts-ignore
import styles from "./StickyElement.module.scss";
export const StickyElement: FC<StickyElementProps> = ({
  content,
  show_on_desktop,
  show_on_mobile,
  element_scroll_trigger_point,
  expand_button_full_width_on_mobile,
  phoneNumber,
  parseMetadata,
  ...rest
}) => {
  // const inspector = useContentfulInspectorMode();
  const stickyElementRef = useRef<HTMLDivElement>(null);
  const buttonContentRef = useRef<HTMLDivElement>(null);
  const tileContentRef = useRef<HTMLDivElement>(null);
  const [elementWidth, setElementWidth] = useState(0);
  const stickyElementTriggerPoint = {
    "--element-scroll-trigger-point": element_scroll_trigger_point,
  } as React.CSSProperties;
  const stickyElementWidth = {
    "--element-width": elementWidth + "px",
  } as React.CSSProperties;

  // Add a scroll event listener to handle visibility based on scroll percentage
  useEffect(() => {
    const handleScroll = () => {
      if (stickyElementRef.current) {
        // Calculate what percentage of the page has been scrolled
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrollPercentage = (scrollTop / scrollHeight) * 100;

        // Compare with the trigger point (defaulting to 10% if not provided)
        if (scrollPercentage >= (element_scroll_trigger_point || 10)) {
          stickyElementRef.current.classList.add("show");
          checkForElement();
        } else {
          stickyElementRef.current.classList.remove("show");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [element_scroll_trigger_point]);

  const checkForElement = () => {
    const contentRef = buttonContentRef.current || tileContentRef.current;
    if (contentRef) {
      setElementWidth(contentRef.offsetWidth);
      return true;
    }
  };

  useEffect(() => {
    checkForElement();
  }, []);

  return (
    <div
      ref={stickyElementRef}
      className={cn(styles.stickyElement, {
        [styles.showOnDesktop]: show_on_desktop,
        [styles.showOnMobile]: show_on_mobile,
        [styles.expandButtonFullWidthOnMobile]: expand_button_full_width_on_mobile,
      })}
      style={stickyElementTriggerPoint}
    >
      <div className={styles.stickyElementSpacer} style={stickyElementWidth} />
      {content?.map((item) => {
        if (item?.sys.contentType.sys.id === "button") {
          const { fields } = (item || {}) as TypeButtonWithoutUnresolvableLinksResponse;
          return (
            <div key={item?.sys?.id} ref={buttonContentRef}>
              <Button {...fields}>{fields?.label || ""}</Button>
            </div>
          );
        } else if (item?.sys.contentType.sys.id === "tile") {
          return (
            <div key={item?.sys?.id} className={styles.stickyElementContent}>
              <div className={styles.stickyElementTileContent} ref={tileContentRef}>
                <Tile
                  content={item as TypeTileWithoutUnresolvableLinksResponse}
                  variation="default"
                  padded={false}
                  phoneNumber={phoneNumber}
                  parseMetadata={parseMetadata}
                />
              </div>
            </div>
          );
        }
      })}
    </div>
  );
};
